import { routeMatch } from '../modules/utils';

if (!routeMatch('/projects') && !routeMatch('/live-sessions')) {
  import('./fontawesome');
}
